module.exports = __webpack_public_path__ + "media/images/user-icon-c2876ea838d373bdfabe6b1fd71f7edd.png";